{
  "AgentAdvanced_Fields_LicenceType": "Call Center Lizenztyp:",
  "AgentAdvanced_Fields_InternalNumber": "Interne Nummer:",
  "AgentAdvanced_Fields_CiscoCommonID": "Cisco Common Identity:",
  "AgentAdvanced_Fields_OverrideMonitoring": "Override-Überwachung:",
  "AgentAdvanced_Fields_WebexCallingUserID": "Webex Calling Benutzer-ID:",
  "AgentAdvanced_Fields_BroadworksUserID": "BroadWorks-Benutzer-ID:",
  "AgentAdvanced_Fields_TeamsUserID": "MS Teams Benutzer-ID:",
  "AgentAdvanced_Fields_UserPrincipalName": "Benutzerprinzipalname (URN):",
  "AgentAdvanced_Fields_OwningGroupID": "ID der besitzenden Gruppe:",
  "AgentAdvanced_Fields_OIDOnTelephoneServer": "OID auf dem Telefon-Server:",
  "AgentAdvanced_Fields_OwningDepartment": "Zuständige Abteilung (vollständiger Pfad):",
  "CallCentreLicenceTypes_None": "[Keiner]",
  "CallCentreLicenceTypes_Basic": "Grundlegend",
  "CallCentreLicenceTypes_Standard": "Standard",
  "CallCentreLicenceTypes_Premium": "Prämie",
  "NAME": "AgentAdvanced"
}